@if (objectForm) {
    <nz-spin [nzSpinning]="loading">
        <form nz-form [formGroup]="objectForm" class="login-form" nzLayout="vertical">
            <div nz-row nzGutter="8">
                <div nz-col [nzXXl]="12" [nzXl]="12" [nzLg]="12" [nzMd]="12" [nzSm]="24" [nzXs]="24">
                    <nz-form-item>
                        <nz-form-label nzRequired nzFor="startDate">Sākuma datums</nz-form-label>
                        <nz-form-control clValidationError="startDate">
                            <nz-date-picker
                                style="width: 100%"
                                nz-input
                                id="startDate"
                                formControlName="startDate"
                                nzPlaceHolder="Sākuma datums"
                                [nzFormat]="DATE_FORMAT"
                                [nzDisabledDate]="disabledDate"
                            ></nz-date-picker>
                        </nz-form-control>
                    </nz-form-item>
                </div>
                <div nz-col [nzXXl]="12" [nzXl]="12" [nzLg]="12" [nzMd]="12" [nzSm]="24" [nzXs]="24">
                    <nz-form-item>
                        <nz-form-label nzRequired nzFor="endDate">Beigu datums</nz-form-label>
                        <nz-form-control clValidationError="endDate" nzHasFeedback nzValidatingTip="Pārbauda...">
                            <nz-date-picker
                                style="width: 100%"
                                nz-input
                                id="endDate"
                                formControlName="endDate"
                                nzPlaceHolder="Beigu datums"
                                [nzFormat]="DATE_FORMAT"
                                [nzDisabledDate]="disabledDate"
                            ></nz-date-picker>
                        </nz-form-control>
                    </nz-form-item>
                </div>
            </div>
        </form>
        <div *nzModalFooter class="modal-footer">
            <div class="modal-footer-left">
                @if (isEditMode) {
                    <cl-info-button [id]="originalObject.id" [entityType]="EntityType.Absence" (loadingChanged)="loading = $event"></cl-info-button>
                    <cl-notification-history-button
                        [entityType]="EntityType.Absence"
                        [id]="originalObject.id"
                        class="ml-2"
                    ></cl-notification-history-button>
                }
            </div>
            <div class="modal-footer-right">
                <ng-container>
                    <button nz-button nzType="default" [disabled]="loading" (click)="cancel()">Aizvērt</button>
                    <button nz-button nzType="primary" [disabled]="loading" (click)="validateAndSave()">Saglabāt</button>
                </ng-container>
            </div>
        </div>
    </nz-spin>
}
